import type { WindPluginFactories } from './weather-layer-controller';

declare global {
  interface Window {
    MaplibreWindGL?: any;
  }
}

const scriptLoads = new Map<string, Promise<void>>();

function loadScriptOnce(id: string, src: string) {
  const existing = scriptLoads.get(id);
  if (existing) return existing;
  const loading = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.id = id;
    script.src = src;
    script.async = true;
    script.onload = () => resolve();
    script.onerror = () => {
      script.remove();
      scriptLoads.delete(id);
      reject(new Error(`Failed to load ${src}`));
    };
    document.head.appendChild(script);
  });
  scriptLoads.set(id, loading);
  return loading;
}

export async function prepareWindPlugins(
  installPluginRuntime: () => void,
  assetUrl: (path: string) => string
): Promise<WindPluginFactories> {
  installPluginRuntime();
  await loadScriptOnce('maplibre-wind-gl-js', assetUrl('lib/maplibre-wind-gl.js?v=gpu-local-v2'));
  if (!window.MaplibreWindGL) throw new Error('Wind plugin unavailable');
  return {
    createLayer: ({ id, ...options }) => new window.MaplibreWindGL(id, options)
  };
}
